import DataTable from '../../components/DataTable';
import { formatDate, placeLabel } from '../../utils/formatters';
const columns = [
  {
    key: 'place',
    label: 'מקום',
    render: (report) => placeLabel(report.place),
  },
  {
    key: 'reporter',
    label: 'מדווח',
    render: (report) => report.reporter?.userId || report.anonymousId || report.deviceId || '-',
  },
  {
    key: 'source',
    label: 'מקור',
    render: (report) => report.source,
  },
  {
    key: 'loadScore',
    label: 'עומס',
    render: (report) => report.loadScore,
  },
  {
    key: 'createdAt',
    label: 'נוצר',
    render: (report) => formatDate(report.createdAt),
  },
  {
    key: 'validUntil',
    label: 'בתוקף עד',
    render: (report) => formatDate(report.validUntil),
  },
];
const ReportsPage = ({ reports, filters, setFilters, loadReports, loading }) => {
  return (
    <section className="work-area table-page" dir="rtl">
      <header className="section-header">
        <div>
          <h1>דיווחים</h1>
          <span>{reports.total} דיווחים</span>
        </div>
        <div className="filters">
          <input
            type="date"
            value={filters.from}
            onChange={(e) =>
              setFilters({
                ...filters,
                from: e.target.value,
              })
            }
          />
          <input
            type="date"
            value={filters.to}
            onChange={(e) =>
              setFilters({
                ...filters,
                to: e.target.value,
              })
            }
          />
          <input
            placeholder="Place ID"
            value={filters.placeId}
            onChange={(e) =>
              setFilters({
                ...filters,
                placeId: e.target.value,
              })
            }
          />
          <input
            placeholder="Source"
            value={filters.source}
            onChange={(e) =>
              setFilters({
                ...filters,
                source: e.target.value,
              })
            }
          />
          <button onClick={() => loadReports(1)}>סינון</button>
        </div>
      </header>
      <DataTable
        columns={columns}
        items={reports.items}
        rowKey={(report) => report._id || report.id}
        page={reports.page}
        limit={reports.limit}
        total={reports.total}
        onPageChange={loadReports}
        loading={loading}
      />
    </section>
  );
};
export default ReportsPage;
